<template>
  <div style="display: flex; justify-content: center">
    <div class="MainDiv">
      <div style="margin-bottom: 1rem">
        <v-img
          src="https://www.bodytalksystem.com/images/access_banner1.jpg"
          contain
        ></v-img>
      </div>
      <div style="display: flex">
        <div style="max-width:25%; padding-right:1rem;    border-right: 1px dashed gray;">
          <p><b>Join our online community</b></p>
          <p>
            A great place to talk to other graduates and get continued education
            and insight from instructors is on the IBA forum. The forum is one
            of the benefits you gain from becoming an IBA member. For
            information on IBA membership
            <a
              href="https://www.bodytalksystem.com/membership?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=membership"
              >click here</a
            >.<br />
            <br />
          </p>

          <p><b>The Cortices Video</b></p>
          <p>
            You can now share what you have learnt with your family and friends,
            by teaching them how to tap out their own cortices. We have a video
            demonstration of this technique so anyone can learn.
            <a href="https://www.youtube.com/watch?v=LqzsfszL4lc&t=75s"
              ><br />Watch now!</a
            ><br />
            <br />
          </p>

          <p><b>Try BodyTalk</b></p>
          <p>
            You may also be interested in receiving a session by a Certified
            BodyTalk Practitioner in your area.<br />
            To find practitioners in your area
            <a
              href="http://www.bodytalksystem.com/practitioners/?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=practitioners"
            >
              Click Here</a
            ><br />
            <br />
          </p>

          <p><b>IBA Newsletter</b></p>
          <p>
            Stay up to date with the latest information, happenings and stories
            in the BodyTalk community.<br />
            <a
              href="http://www.bodytalksystem.com/learn/news/newsletter.cfm?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=newsletter"
              style="
                color: #003366;
                text-decoration: underline;
                font-weight: normal;
              "
              >Sign up today</a
            ><br />
          </p>

          <br />
        </div>
        <div style="max-width:75%; padding-left:1rem;">
          <h4><b>Congratulations, #createEvaluation.StudentFname#!</b></h4>
          <p>
            Welcome to the IBA! We would like to take this opportunity to
            congratulate you on completing the BodyTalk Access training. You now
            have a wonderful tool to maintain and improve both your own and
            others’ state of health.
            <br /><br />
            Please make sure to practice the BodyTalk Access Routine as outlined
            in the manual so that it is easily committed to memory and can
            become a natural and healthy part of your day and week.
            <br /><br />
            Have Feedback? Let us know what you though of your recent learning
            experience!
            <a
              href="https://evaluations.bodytalksystem.com/default.aspx?id=#createEvaluation.LinkId#"
              >Click here</a
            >.
            <br />
            <br />
            If you have specific issues or other matters you wish to raise, you
            can email us at:
            <a href="mailto:feedback@bodytalksystem.com"
              >feedback@bodytalksystem.com</a
            ><br />
            <br />
          </p>

          <p><b>What's Next?</b></p>
          <p>
            One of the most asked questions is &ldquo;Should I sign up for
            BodyTalk Fundamentals?&rdquo; <br /><br />
            The answer is &ldquo;yes&rdquo; if... &nbsp;
          </p>

          <ul>
            <li>
              You enjoyed BodyTalk Access and want to learn more about the
              system.
            </li>
            <li>
              Want to learn techniques that can address wider health situations
              - emotional, physical, and spiritual.
            </li>
            <li>Want to further your personal development.</li>
            <li>Want to take any of the Advanced BodyTalk Courses.</li>
            <li>Want a career change or to earn extra money.</li>
            <li>Want to further help family and friends.</li>
            <li>Want to become a Certified BodyTalk Practitioner.</li>
            <li>
              Interested in BodyTalk Fundamentals? <br /><a
                href="http://www.bodytalksystem.com/seminars/?course=1&utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=mod12"
                >Follow this link</a
              >.
            </li>
          </ul>

          Detailed information about International BodyTalk Association&rsquo;s
          courses, membership, and foundation can be found on IBA&rsquo;s
          website located at:
          <a
            href="http://www.bodytalksystem.com/?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=iba"
            >www.ibaglobalhealing.com</a
          >.<br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessGraduation",
};
</script>

<style scoped>
.MainDiv {
  padding: 2rem;
  align-content: center;
  max-width: 1000px;
}
</style>
